/**
 * @file: layoutMetrics.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { Insets } from 'react-native';

export type LayoutInsets =
  | number
  | { horizontal: number; vertical: number }
  | Required<Insets>;

export type GridViewLayoutMetrics = {
  padding: LayoutInsets;
  cell: {
    margin: LayoutInsets;
    /** item preferred aspect ratio as width / height */
    aspectRatio: number;
  };
};

export const layoutInsetsReduced = (insets: LayoutInsets): Required<Insets> => {
  if (typeof insets === 'number') {
    return { top: insets, right: insets, bottom: insets, left: insets };
  }
  if ('horizontal' in insets && 'vertical' in insets) {
    return {
      top: insets.vertical,
      right: insets.horizontal,
      bottom: insets.vertical,
      left: insets.horizontal,
    };
  }
  return insets;
};

export const insetsToCssValue = (insets: Required<Insets>) =>
  [insets.top, insets.right, insets.bottom, insets.left]
    .map(x => `${x}px`)
    .join(' ');

export const computeGridLayoutItemSize = (metrics: {
  numberOfColumns: number;
  gridWidth: number;
  gridPadding: LayoutInsets;
  cellMargin: LayoutInsets;
  aspectRatio: number;
}) => {
  const { gridWidth, numberOfColumns, aspectRatio } = metrics;
  const gridPadding = layoutInsetsReduced(metrics.gridPadding);
  const cellMargin = layoutInsetsReduced(metrics.cellMargin);
  const width =
    Math.floor(
      (gridWidth - gridPadding.left - gridPadding.right) / numberOfColumns,
    ) -
    (cellMargin.left + cellMargin.right);
  const height = width / aspectRatio;
  return [width, height];
};
